module.exports = __webpack_public_path__ + "img/device_img11.2794bcba.png";